var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x31_px",
    enableBackground: "new 0 0 24 24",
    height: 17,
    viewBox: "0 0 24 24",
    width: 17,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.5 15c-.276 0-.5-.224-.5-.5 0-3.033-2.467-5.5-5.5-5.5h-8v3.5c0 .202-.122.385-.309.462-.186.08-.401.036-.545-.108l-5.5-5.5c-.195-.195-.195-.512 0-.707l5.5-5.5c.144-.144.358-.188.545-.109.187.077.309.26.309.462v3.5h7c4.136 0 7.5 3.364 7.5 7.5v2c0 .276-.224.5-.5.5zm-19.293-8 4.293 4.293v-2.793c0-.276.224-.5.5-.5h8.5c2.142 0 4.045 1.042 5.23 2.645-.8-2.683-3.291-4.645-6.23-4.645h-7.5c-.276 0-.5-.224-.5-.5v-2.793z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15 23c-.064 0-.129-.012-.191-.038-.187-.077-.309-.26-.309-.462v-3.5h-7c-4.136 0-7.5-3.364-7.5-7.5v-2c0-.276.224-.5.5-.5s.5.224.5.5c0 3.033 2.467 5.5 5.5 5.5h8v-3.5c0-.202.122-.385.309-.462.188-.077.402-.035.545.108l5.5 5.5c.195.195.195.512 0 .707l-5.5 5.5c-.096.096-.224.147-.354.147zm-13.73-9.645c.8 2.683 3.291 4.645 6.23 4.645h7.5c.276 0 .5.224.5.5v2.793l4.293-4.293-4.293-4.293v2.793c0 .276-.224.5-.5.5h-8.5c-2.142 0-4.045-1.042-5.23-2.645z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/transfer.a68a2f0cec1d549f85ba169b5ac52eea.svg";
export { ForwardRef as ReactComponent };